import IPhoneNumber from "@/app/dto/IPhoneNumber";
import OtpRequest from "@/app/dto/OtpRequest";
import Property from "@/app/dto/Property";

export default class CreateKeyOtp extends OtpRequest {
    constructor(public send: boolean, mobile?: IPhoneNumber, data?: Property[]) {
        super(mobile, data);
    }
}
